import type { DictionaryEntry, DictionaryStore } from "./types";
import { loadDictionary } from "./dictionary-parser";
import { buildTrie } from "./trie";

function normalizeJyutping(jyutping: string): string {
  return jyutping.toLowerCase().replace(/\s+/g, " ").trim();
}

function buildTraditionalIndex(
  entries: DictionaryEntry[]
): Map<string, DictionaryEntry[]> {
  const index = new Map<string, DictionaryEntry[]>();

  for (const entry of entries) {
    const key = entry.traditional;
    const existing = index.get(key);
    if (existing) {
      existing.push(entry);
    } else {
      index.set(key, [entry]);
    }
  }

  return index;
}

function buildJyutpingIndex(
  entries: DictionaryEntry[]
): Map<string, DictionaryEntry[]> {
  const index = new Map<string, DictionaryEntry[]>();

  for (const entry of entries) {
    const key = normalizeJyutping(entry.jyutping);
    const existing = index.get(key);
    if (existing) {
      existing.push(entry);
    } else {
      index.set(key, [entry]);
    }
  }

  return index;
}

export async function initializeDictionary(): Promise<DictionaryStore> {
  const entries = await loadDictionary();
  const trieRoot = buildTrie(entries);
  const traditionalIndex = buildTraditionalIndex(entries);
  const jyutpingIndex = buildJyutpingIndex(entries);

  return {
    entries,
    trieRoot,
    traditionalIndex,
    jyutpingIndex,
  };
}
